
  import Vue from 'vue';
  export default {
    scrollToTop: true,
    head() {
      return {
        title: this.title,
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title
          },
          {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Jai Devi Jai Mahalakshmi" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Jai Devi Jai Mahalakshmi" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Jai Devi Jai Mahalakshmi Aarti, Mahalakshmi Aarti, Devi Aarti, Jai Mahalakshmi, Mahalakshmi Mata Aarti, Lakshmi Aarti'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jai Devi Jai Mahalakshmi Aarti, Mahalakshmi Aarti, Devi Aarti, Jai Mahalakshmi, Mahalakshmi Mata Aarti, Lakshmi Devi Aarti, Lakshmi Aarti, Lakshmi Pooja, Diwali Aarti, Marathi Aarti, Mahalaxmi Aarti in Marathi, Lakshmi prayer, Devi Lakshmi Bhakti, Hindu devotional Aarti, Mahalakshmi Bhajan, Jai Devi Aarti lyrics, जय देवी जय देवी आरती, महालक्ष्मी आरती मराठी , महालक्ष्मी आरती lyrics marathi, jay devi jay devi jay mahalaxmi aarti lyrics'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/mahalaxmi.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/mahalaxmi.webp'
          },
        ],
      }
    },
  
    components: {
      },
      data() {
        return {
          title: 'Jai Devi Jai Mahalakshmi |  Mahalakshmichi Aarti - जय देवी जय महालक्ष्मी (महालक्ष्मीची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/mahalaxmi"
        },
        "headline": "Jai Devi Jai Mahalakshmi - जय देवी जय महालक्ष्मी (महालक्ष्मीची आरती)",
        "name" : "Jai Devi Jai Mahalakshmi - Mahalakshmichi Aarti",
        "description": "Explore the full lyrics of Aarti 'Jai Devi Jai Mahalakshmi' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/mahalaxmi.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }
  
    }
  